import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";

export const RunsList = () => {
  const [runs, setRuns] = useState(null);
  useEffect(() => { api.get("/runs").then((r) => setRuns(r.data)); }, []);
  return (
    <div className="overflow-hidden rounded-2xl border bg-card" data-testid="runs-list">
      {runs?.length === 0 && <p className="px-5 py-10 text-sm text-muted-foreground">No runs recorded yet.</p>}
      {runs?.map((r) => (
        <Link key={r.id} to={`/runs/${r.id}`} data-testid={`run-row-${r.id}`} className="flex items-center justify-between gap-3 border-b px-5 py-4 last:border-0 hover:bg-secondary/50">
          <div className="min-w-0">
            <div className="truncate font-semibold">{r.bike_name} · {r.rider_name}</div>
            <div className="text-xs text-muted-foreground">{fmtDateTime(r.created_at)} · {r.pre.mileage}{r.post ? ` → ${r.post.mileage} (${r.miles} mi)` : ""}</div>
          </div>
          <div className="flex flex-col items-end gap-1">
            <span className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold ${r.status === "out" ? "border-sky-500/40 text-sky-300" : "border-emerald-500/40 text-emerald-300"}`}>{r.status === "out" ? "Out" : "Completed"}</span>
            {r.fault_count > 0 && <span className="text-[11px] font-semibold text-amber-400">{r.fault_count} fault{r.fault_count > 1 ? "s" : ""}</span>}
          </div>
        </Link>
      ))}
    </div>
  );
};
